<template>
    <div id="app">
        <AdvancedSearchMulti></AdvancedSearchMulti>
    </div>
</template>

<script>
import AdvancedSearchMulti from './components/AdvancedSearchMulti'

export default {
  name: 'app',
  components: {
    AdvancedSearchMulti
  }
}
</script>

<style lang="scss">
    @use "../../../assets/css/init.scss" as init;
</style>
